import { FC, ReactElement, useCallback } from 'react';
import SingleChoiceOption from './components/SingleChoiceOption';
import { ICurrencySettings } from 'src/types/branches';
import { IResponseProductModifier, IResponseProductModifierOption } from 'src/types/products';
import { getTranslate } from 'src/utils/helpers';
import './style.scss';

interface IProps {
  modifier: IResponseProductModifier;
  error: boolean;
  onChange: (modifier: IResponseProductModifier) => void;
  currencySettings?: ICurrencySettings;
}

const SingleChoice: FC<IProps> = ({ modifier, ...props }: IProps): ReactElement => {
  const onPressOption = useCallback(
    (option: IResponseProductModifierOption) => {
      let isSameOption: boolean = true;

      const options: IResponseProductModifierOption[] = modifier.options.map((_option) => {
        if (_option.id === option.id) {
          isSameOption = Boolean(_option.selected);
          return { ..._option, selected: true };
        }

        return { ..._option, selected: false };
      });

      // do not call on change if user pressed on same option
      if (isSameOption) return;

      props.onChange({ ...modifier, options });
    },
    [modifier, modifier.options]
  );

  return (
    <div className="single-choice">
      <h3 className="single-choice__title">{getTranslate(modifier.name)}</h3>
      {modifier.options.map((option) => (
        <SingleChoiceOption key={option.id} option={option} onPressOption={onPressOption} currencySettings={props.currencySettings} />
      ))}
    </div>
  );
};

export default SingleChoice;
